import { render } from "./TransferDetails.vue?vue&type=template&id=752a0ff8&scoped=true"
import script from "./TransferDetails.vue?vue&type=script&lang=js"
export * from "./TransferDetails.vue?vue&type=script&lang=js"

import "./TransferDetails.vue?vue&type=style&index=0&id=752a0ff8&lang=postcss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752a0ff8"]])

export default __exports__